module.exports = __webpack_public_path__ + "img/route_2.840d4557.png";